<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>

<ng-container *ngIf="!isSpinner && attempt as exam">
<div class="result-page" *ngIf="exam.result as result">
  <a class="back-link" [routerLink]="['/mock']">{{ 'mockBack' | translate }}</a>

  <section class="score-hero">
    <p class="paper-kicker">Paper {{ exam.paper }}</p>
    <h1>{{ 'mockResultTitle' | translate }}</h1>
    <p class="score">{{ result.score }} / {{ result.max_score }}</p>
    <p class="percent">{{ percentText(result.percentage) }}</p>
    <span class="badge" [class.badge-pass]="result.passed" [class.badge-fail]="!result.passed">
      {{ (result.passed ? 'mockPassed' : 'mockFailed') | translate }}
    </span>
    <p class="guide">{{ guideText() }}</p>
  </section>

  <section class="areas">
    <h2>{{ 'mockAreas' | translate }}</h2>
    <nz-table nzTemplateMode>
      <thead>
        <tr>
          <th>{{ 'mockArea' | translate }}</th>
          <th>{{ 'mockScore' | translate }}</th>
          <th>%</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let area of result.areas">
          <td>{{ area.area_label }}</td>
          <td>{{ area.score }} / {{ area.max_score }}</td>
          <td>{{ percentText(area.percentage) }}</td>
        </tr>
      </tbody>
    </nz-table>
  </section>

  <section class="review">
    <h2>{{ 'mockReview' | translate }}</h2>
    <article class="review-card" *ngFor="let item of result.review; let i = index">
      <p class="area-kicker">{{ item.area_label }}</p>
      <div class="question-text">
        <span class="question-id">{{ i + 1 }}.</span>
        <span>{{ item.question_text }}</span>
      </div>
      <div class="question-image-wrapper" *ngIf="item.image">
        <img [src]="item.image" alt="" />
      </div>

      <div class="review-option" *ngFor="let option of item.options">
        <div [ngClass]="rowClass(option)">
          <div [ngClass]="circleClass(option)">
            {{ letter(option.index) }}
            <span class="option-state-icon" aria-hidden="true">{{ resultIcon(option) }}</span>
          </div>
          <span>{{ option.text }}</span>
        </div>
        <p class="review-meta">
          {{ 'mockYourAnswer' | translate }}: {{ answerLabel(option.user_answer) }}
          · {{ 'mockCorrectIs' | translate }}: {{ answerLabel(option.is_correct) }}
          · {{ pointsLabel(option.points) }}
        </p>
        <div *ngIf="option.explanation" [ngClass]="explanationClass(option)">
          <span>{{ option.explanation }}</span>
        </div>
      </div>

      <p class="hint" *ngIf="item.hint"><strong>{{ 'mockHint' | translate }}:</strong> {{ item.hint }}</p>
      <div class="question-source" *ngIf="item.question_source_link || item.question_source_name">
        <div><span>{{ 'source' | translate }}</span></div>
        <div class="source">
          <a *ngIf="item.question_source_link" [href]="item.question_source_link" target="_blank" rel="noopener noreferrer">
            {{ item.question_source_name || item.question_source_link }}
          </a>
          <span *ngIf="!item.question_source_link">{{ item.question_source_name }}</span>
        </div>
      </div>
    </article>
  </section>
</div>
</ng-container>

<app-mock-subscription *ngIf="!isSpinner && subscriptionRequired"></app-mock-subscription>
<p class="load-error" *ngIf="!isSpinner && loadError && !subscriptionRequired">{{ 'mockLoadError' | translate }}</p>
